"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_click_listener_for_attr_1 = __importDefault(require("../utils/add-click-listener-for-attr"));
var reveal = function (id) {
    var el = document.getElementById(id);
    if (el) {
        el.style.display = 'block';
    }
};
(0, add_click_listener_for_attr_1.default)('data-reveal', reveal);
